import { InjectedComponent, isUrl, useSelector } from '@topwrite/common';
import { useCallback } from 'react';

interface Props {
    element: 't-attachment' | 'img' | 'video' | 'audio';
    src?: string;
}

export default function Asset({ element, src, ...props }: Props) {
    const { lfs, file } = useSelector('page');

    if (src && !isUrl(src) && file && lfs) {
        const { url, files } = lfs;
        const filename = file.resolve(decodeURIComponent(src));
        const oid = files[filename];

        if (oid) {
            src = url.replace('{oid}', oid);
        }
    }

    const component = useCallback(function({ src, ...props }: Omit<Props, 'element'>) {
        if (src && !isUrl(src) && file && src.startsWith('/')) {
            src = file.relative(src.slice(1));
        }
        return <InjectedComponent
            role={'page:asset'}
            props={{
                src,
                ...props
            }}
            component={element}
        />;
    }, [element]);

    return <InjectedComponent
        role={'page:asset:source'}
        props={{
            src,
            ...props
        }}
        component={component}
    />;
}
